import { api, method } from '../api/apiClient';

export const getCategories = async (hotelId) => {
    try {
        return await api(method.GET, `/menu/category/${hotelId}`);
    } catch (error) {
        console.error(`Error while fetching category ${error}`);
        throw error;
    }
};

export const createCategories = async (payload) => {
    try {
        return await api(method.POST, `/menu/category`, payload, { 'Content-Type': 'multipart/form-data' });
    } catch (error) {
        console.error(`Error while creating category ${error}`);
        throw error;
    }
};

export const updateCategory = async (categoryId, payload) => {
    try {
        return await api(method.PUT, `/menu/category/${categoryId}`, payload, { 'Content-Type': 'multipart/form-data' });
    } catch (error) {
        console.error(`Error while updating category ${error}`);
        throw error;
    }
};

export const removeCategories = async (payload) => {
    try {
        return await api(method.DELETE, `/menu/category`, payload);
    } catch (error) {
        console.error(`Error while creating category ${error}`);
        throw error;
    }
};

export const fetchMenuItems = async ({
    categoryId,
    skip = 0,
    limit = 10,
    sortKey = '',
    sortOrder = '',
    filterKey = '',
    filterValue = ''
}) => {
    try {
        const query = `skip=${skip}&limit=${limit}&sortKey=${sortKey}&sortOrder=${sortOrder}&filterKey=${filterKey}&filterValue=${filterValue}`;
        return await api(method.GET, `/menu/${categoryId}?${query}`);
    } catch (error) {
        console.error(`Error while fetching menu items ${error}`);
        throw error;
    }
};

export const saveMenuItems = async (payload) => {
    try {
        return await api(method.POST, `/menu`, payload, { 'Content-Type': 'multipart/form-data' });
    } catch (error) {
        console.error(`Error while storing menu items ${error}`);
        throw error;
    }
};

export const removeMenuItems = async (payload) => {
    try {
        return await api(method.DELETE, `/menu`, payload);
    } catch (error) {
        console.error(`Error while removing menu items ${error}`);
        throw error;
    }
};

export const updateMenuItem = async (id, payload) => {
    try {
        return await api(method.PUT, `/menu/${id}`, payload, { 'Content-Type': 'multipart/form-data' });
    } catch (error) {
        console.error(`Error while updating menu item ${error}`);
        throw error;
    }
};
